import React from "react";
import ReactDom from "react-dom"; 
import "./modalToggle.css";
import ZmodalCloser from "./images/modal-closer.png";
import ZmodalTop from "./images/modal-top.png";
import ZmodalBottom from "./images/modal-bott.png";
import PrintRendering from '../../images/print_lg/rendering1_lg.jpg';

export default function PrintRenderingModal(props) {
  const renderingModalState = props.toggle
  const action = props.action

  return ReactDom.createPortal (
    <>
    
    <div className={`z-container ${renderingModalState ? 'active' : ''}`}>
      <div className="z-modal">
        <div className="z-modal-closer">
          <a className="close" onClick={action} href="#">
            <img src={ZmodalCloser} alt="Close modal window" />
          </a>
        </div>
        <div className="z-modal-header">
          <img alt="" src={ZmodalTop} />
        </div>
        <div className="z-modal-body">
          <img className="img-fluid" alt="Landscape composite imagery- Americas Home Place" src={PrintRendering} />
        </div>
        <div className="z-modal-footer">
          <img alt="" src={ZmodalBottom} />
        </div>
      </div>
    </div>
    </>,
    document.getElementById('modal-root')
  );
}
